import { SELECT_INCIDENT_PRIORITY_FILTER } from "./incidentActionTypes";

export default (state = [], action) => {
  switch (action.type) {
    case SELECT_INCIDENT_PRIORITY_FILTER: {
      const exists = state.filter(f => f === action.value).length > 0;
      if (exists) {
        return state.filter(f => f !== action.value);
      }
      return [...state, action.value];
    }
    case '@@router/LOCATION_CHANGE':
    {
        return [];
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/incidents/incidentsPriorityFilterReducer.js